// @ts-nocheck
import * as ReactDOM from 'react-dom';
import DOMPurify from 'dompurify';

import type IArticleAuthor from './article-author';
// import DataStore from "Services/stores/data-store";

// const decode = require("unescape");

const AMERICAN_SPORTS = ['ice hockey', 'baseball', 'basketball', 'american football'];

export function FormatString(format: string, ...args: Array<string>): string {
  return format.replace(/{(\d+)}/g, function (match, number) {
    return typeof args[number] !== 'undefined' ? args[number] : match;
  });
}

export function getOrdinal(n) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;

  return s[(v - 20) % 10] || s[v] || s[0];
}

export function capitalizeFirstLetter(str = '') {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function capitalizeFirstLetterOfPhrase(str) {
  const lowercaseString = str.toLowerCase();

  return lowercaseString[0].toUpperCase() + lowercaseString.slice(1);
}

export function lowercase(str) {
  if (!str) return '';

  return str.toLowerCase();
}

export function getCountryCode(countryCode) {
  switch (countryCode) {
    case 'AUS':
      return 'AU';
    case 'UK':
      return 'GB';
    case 'SWE':
      return 'SE';
    case 'IRE':
      return 'IE';
    case 'FRA':
      return 'FR';
    case 'RSA':
      return 'ZA';
    case 'IND':
      return 'IN';
    default:
      return countryCode;
  }
}

/**
 * Scroll to a given element, with optional topOffset
 *
 * @export
 * @param {any} target Element you want to scroll to
 * @param {number} topOffset Top offset to ensure element not hidden by menu
 */
export function scrollTo(target: HTMLElement | null, topOffset = 0) {
  const targetScrollDepth = target?.getBoundingClientRect()?.top;
  const visibleHeader = document.getElementById(`${targetScrollDepth <= 0 ? 'headerWrapper' : 'headerSubMenu'}`);

  let visibleHeaderHeight = 0;
  if (visibleHeader) {
    visibleHeaderHeight = visibleHeader?.getBoundingClientRect()?.height;
  }

  const windowScrollDepth = window.scrollY || (document.documentElement || document.body).scrollTop;

  window.scrollTo({
    left: 0,
    top: targetScrollDepth + windowScrollDepth - visibleHeaderHeight + topOffset,
    behavior: 'smooth',
  });
}

/**
 * Scrolls to top of page
 *
 */
export function scrollToTop(element: HTMLElement) {
  if (window.scrollY) {
    // reset the scroll position to the top left of the document.
    try {
      element.scrollIntoView({ behavior: 'smooth' });
    } catch (err) {
      if (err instanceof TypeError) {
        window.scrollTo(0, 0);
      } else {
        throw err;
      }
    }
  }
}

export function pageScroll() {
  // return document.body.scrollTop || document.documentElement.scrollTop;
  return window.scrollY || document.documentElement.scrollTop;
}

export function isOverflown(element: HTMLElement) {
  if (element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
  }
}

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
export function detectIE10AndBelow(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const ua = window.navigator.userAgent;

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return true;
  }
  // other browser
  return false;
}

export function getInternetExplorerVersion(): number {
  if (typeof window === 'undefined') {
    return -1;
  }

  let rv = -1;
  if (navigator.appName == 'Microsoft Internet Explorer') {
    const ua = navigator.userAgent;
    const re = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');
    if (re.exec(ua) != null) {
      rv = parseFloat(RegExp.$1);
    }
  } else if (navigator.appName == 'Netscape') {
    const ua = navigator.userAgent;
    const re = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})');
    if (re.exec(ua) != null) {
      rv = parseFloat(RegExp.$1);
    }
  }
  return rv;
}

export function detectElementInDOM(element: string): HTMLElement | false {
  if (typeof (document != undefined) && document.getElementById(element)) {
    return document.getElementById(element);
  }
  return false;
}

export function DomPurifySanitize(data: string) {
  if (typeof window !== 'undefined') {
    return DOMPurify.sanitize(data);
  }
  return data;
}

export function isMountedComponent(component: React.Component): boolean {
  // exceptions for flow control :(
  try {
    ReactDOM.findDOMNode(component); // eslint-disable-line react/no-find-dom-node
    return true;
  } catch (e) {
    // Error: Invariant Violation: Component (with keys: props,context,state,refs,_reactInternalInstance) contains `render` method but is not mounted in the DOM
    return false;
  }
}

export function copy<T>(origin: T): T {
  return JSON.parse(JSON.stringify(origin));
}

export function getQueryParam(param: string): string[] {
  if (!param || param.length === 0) {
    return [];
  }

  const query = window.location.search.toLowerCase();
  let values = query.substring(query.indexOf(param) + param.length + 1);
  if (values.indexOf('&') != -1) {
    values = values.substring(0, values.indexOf('&'));
  }

  // if no betIds we return an empty array so we can go into contextualMode.
  if (values.length === 0) {
    return [];
  }

  return values.split(',');
}

type WindowUndefined = { pageYOffset?: number };

export function scrollDoc() {
  const win: Window | WindowUndefined = typeof window !== 'undefined' ? window : {};
  const doc = typeof document !== 'undefined' ? document : { documentElement: {} };
  // IE < 9 & Node
  // @ts-ignore
  let scrollElem = typeof win.pageYOffset === 'undefined' ? doc.documentElement : null;

  function detectScrollElem() {
    const startScrollTop = window.pageYOffset;
    document.documentElement.scrollTop = startScrollTop + 1;
    if (window.pageYOffset > startScrollTop) {
      document.documentElement.scrollTop = startScrollTop;
      // IE > 9 & FF (standard)
      return document.documentElement;
    }
    // Chrome (non-standard)
    return document.scrollingElement || document.body;
  }

  // @ts-ignore
  return scrollElem || (scrollElem = detectScrollElem());
}

// export function htmlDecode(input) {
//   // We need to decode twice as there's an extra pair of &amp chars added into the string
//   return decode(decode(input));
// }

export function removePaginationPageFromUrl(path: string, page: string) {
  const allPaths = path.split('/');

  // We can short curcuit the fn here
  if (allPaths.length === 1) {
    return path;
  }

  // Declare last path variables
  const lastPath = allPaths[allPaths.length - 1];
  const lastPathIsPage = lastPath === page;
  const lastPathIsNumeric = lastPath.match(/\d+/g);

  // Remove last path
  if (lastPathIsPage || lastPathIsNumeric) {
    return allPaths.slice(0, -1).join('/');
  }

  return path;
}

export const getPointSpreadValueFromName = (name: string): string | number => {
  if (typeof name !== 'string') {
    return '';
  }

  let value = name;

  // 1. handle no numbers found, by returning an empty string
  const numbers = value.match(/\d+/g);
  if (!numbers) {
    return '';
  }

  // 2. remove undesired chars from our string, i.e. anything
  // that is not a digit(\d), plus(+), minus(-), or dot(.)
  const invalidCharsRegex = new RegExp(/[^\d+-.]/, 'g');
  if (value.match(invalidCharsRegex)) {
    value = value.replace(invalidCharsRegex, '');
  }

  // 3. locate desired substring index
  const lastIndexOfPlusChar = value.lastIndexOf('+');
  const lastIndexOfMinusChar = value.lastIndexOf('-');

  const hasPlusChar = lastIndexOfPlusChar !== -1;
  const hasMinusChar = lastIndexOfMinusChar !== -1;

  switch (true) {
    case hasPlusChar && hasMinusChar: {
      const [_, lastIndexOfPlusOrMinusChar] = [lastIndexOfPlusChar, lastIndexOfMinusChar].sort();

      return value.substring(lastIndexOfPlusOrMinusChar);
    }
    case hasPlusChar && !hasMinusChar: {
      return value.substring(lastIndexOfPlusChar);
    }
    case !hasPlusChar && hasMinusChar: {
      return value.substring(lastIndexOfMinusChar);
    }
    case !hasPlusChar && !hasMinusChar: {
      return value;
    }
  }
};

export const getTotalValueFromName = (name: string): string => {
  if (typeof name !== 'string') {
    return '';
  }

  return name.replace('Over', 'O').replace('Under', 'U');
};

export const getNameFromPointSpreadValue = (name: string): string => {
  if (typeof name !== 'string') {
    return '';
  }

  return name.replace(/[+-]?(?:\d*\.)?\d+$/, '').trim();
};

export const isMarketHandicap = (market, _sortOption?): boolean => {
  if (!market) {
    return false;
  }
  return market.map === 'point-spread' || market.map === 'run-line';
};

export const isStrictlyUSHandicap = (bet): boolean => {
  if (!bet) {
    return false;
  }
  return bet.marketName === 'Point Spread' || bet.marketName === 'Moneyline' || bet.marketName === 'Runline';
};

// This is faster that Lodash's cloneDeep and preferred as sometimes we need to copy the full Baobab tree
// https://stackoverflow.com/a/44612374
export function cloneDeep(o) {
  let newO;
  let i;

  if (typeof o !== 'object') {
    return o;
  }

  if (!o) {
    return o;
  }

  if (Object.prototype.toString.apply(o) === '[object Array]') {
    newO = [];
    for (i = 0; i < o.length; i += 1) {
      newO[i] = cloneDeep(o[i]);
    }
    return newO;
  }

  newO = {};
  for (i in o) {
    // eslint-disable-next-line no-prototype-builtins
    if (o.hasOwnProperty(i)) {
      newO[i] = cloneDeep(o[i]);
    }
  }
  return newO;
}

export const isAmericanSport = sport => {
  return AMERICAN_SPORTS.includes(sport);
};

export function getTeamNamesFromSubevent(
  subeventName: string,
  isAmericanSport: boolean, // eslint-disable-line @typescript-eslint/no-shadow
) {
  let teamNames = subeventName.split(/ vs | v | - | at /);
  teamNames = isAmericanSport ? teamNames.reverse() : teamNames;
  return teamNames;
}

export const getBookiesByState = (state: string): string[] => {
  const states = {
    NJ: ['UG', 'U1', 'E6', 'U6', 'B3', 'UR', 'UJ', 'U4', 'U7', 'U2', 'U3', 'U5', 'U8', 'OC', 'TU', 'WY'],
    PA: ['E3', 'E2', 'E1'],
  };

  return states[state] || states.NJ;
};

function fallbackCopyTextToClipboard(text: string): Promise<boolean> {
  return new Promise((resolve, _reject) => {
    const textArea = document.createElement('textarea');
    let success = false;
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'successful' : 'unsuccessful';
      console.log(`Fallback: Copying text command was ${msg}`);
      success = successful;
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
      success = false;
    }

    document.body.removeChild(textArea);
    resolve(success);
  });
}

export function copyTextToClipboard(text: string): Promise<boolean> {
  if (!navigator.clipboard) {
    return fallbackCopyTextToClipboard(text);
  }

  return navigator.clipboard.writeText(text).then(
    function () {
      console.log('Async: Copying to clipboard was successful!');
      return true;
    },
    function (err) {
      console.error('Async: Could not copy text: ', err);
      return false;
    },
  );
}

export function formatAsDollars(price: number): string {
  if (!price || isNaN(Number(price))) {
    price = 0;
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(price);
}

/**
 * Formats string with space
 * and replaces with dash
 * e.g This is a test into this-is-a-test
 * @param textWithSpaces
 */
export function formatAsKebabCase(textWithSpaces: string) {
  return textWithSpaces ? textWithSpaces.trim().replace(/\W+/g, '-').toLowerCase() : '';
}

/**
 * Check if API response is JSON
 * @param res
 */
export function responseIsJson(res: Response) {
  return !!~(res.headers.get('content-type') || '').indexOf('application/json');
}

/**
 * Promisified Delay
 * @param timeInMs
 */
export function promisifiedDelay(timeInMs: number) {
  return new Promise(resolve => {
    setTimeout(resolve, timeInMs);
  });
}

/**
 * Return author's name or default name.
 * @param author
 */
export function getAuthorName(author) {
  return author?.name || author?.fullName || author?.shortName || 'OddsChecker';
}

/**
 * Return specified css variable from document.body element
 */
export function retrieveCssVar(cssvar: string) {
  return getComputedStyle(document.body).getPropertyValue(cssvar);
}

/**
 * Return specified css variable from document.body element,
 * strip 'px' affix and parse number
 */
export function retrieveCssLengthVar(cssvar: string) {
  return parseInt(retrieveCssVar(cssvar).replace(/px/, ''), 10);
}

/**
 * Return a separator (, or &) when dealing with multiple authors.
 * @param index
 * @param length
 */
export function getAuthorSeparator(index, length) {
  if (index === 0) return '';

  const lastElement = index + 1 === length;

  return lastElement ? ' & ' : ', ';
}

// export function getClaimOfferLabel() {
//   if (!labelService) {
//     labelService = new LabelService();
//   }

//   const geoState = DataStore.getJsonFor(CLIENT, CONFIGDATA, "geoStateLocation");

//   return geoState == "ON"
//     ? labelService.get("CLAIM_OFFER_ON")
//     : labelService.get("CLAIM_OFFER");
// }

export const leagueHasIcon = (league: string) =>
  ['NFL', 'NBA', 'MLB', 'NHL', 'NCAAF', 'NCAAB', 'MLS'].includes(league.toUpperCase());

export const leagueFileName = (displayName: string): string => {
  return `League${displayName.replace(/[ /]/g, '')}`;
};

export const sportIconFile = (name: string): string => {
  return `Tag${name.charAt(0).toUpperCase() + name.slice(1)}`;
};

export const getSeparatorIcon = (separator: string) => {
  const regex = /(?<type>(league|sport))-(?<value>.+)/;
  const { type, value } = regex.exec(separator)?.groups || {};

  if (type === 'league') {
    const leagueIcon = leagueHasIcon(value);

    return leagueIcon && leagueFileName(value.toUpperCase());
  }

  const abbreviatedWords = ['mma', 'mls'];

  if (type === 'sport') {
    const sanitisedValue = value
      .split('-')
      .map((word, _, arr) => {
        if (arr.length === 1) {
          return capitalizeFirstLetter(word);
        }

        if (word === 'soccer') {
          return;
        }

        if (leagueHasIcon(word)) {
          return;
        }

        return abbreviatedWords.includes(word) ? word.toUpperCase() : capitalizeFirstLetter(word);
      })
      .join('');

    // Temporary solution for handling league icons that don't have a `league-` prefix
    if (
      sanitisedValue === 'PremierLeague' ||
      sanitisedValue === 'ChampionsLeague' ||
      sanitisedValue === 'LaLiga' ||
      sanitisedValue === 'WorldCup'
    ) {
      return leagueFileName(sanitisedValue);
    }

    return sportIconFile(sanitisedValue);
  }
};

// TODO: reintroduce dataStore object...
export const replaceOrPushHistoryState = (customLocation: string) => {
  const dataStore = {}; // JSON.parse(JSON.stringify(DataStore.getJsonMutable()));

  if (history.state !== null) {
    window.history.replaceState(dataStore, null, customLocation);
  } else {
    window.history.pushState(dataStore, null, customLocation);
  }
};

export const removeModalSearchParamsFromUrl = () => {
  const currentPage = window.location.href;
  const { currentPath, hasSearchParams, hashFragment, searchParams } = getSearchParamsAndHashFragment(currentPage);

  if (hasSearchParams) {
    // NOTE: we intentionally include ocpremium in both groups to
    // cover cases where ocpremium is found without status param
    const premiumParams = ['ocpremium', 'status'];
    const generalParams = ['ocpremium', 'signup', 'login', 'accountpersonalisation'];

    // Remove both ocpremium and status search params
    const hasOCPremiumAndStatusParams = premiumParams.every(param => searchParams.has(param));
    if (hasOCPremiumAndStatusParams) {
      for (const param of premiumParams) {
        searchParams.delete(param);
      }
    }

    // Remove individual search params
    for (const [key] of searchParams) {
      if (generalParams.length === 0) break;

      const generalParamIndex = generalParams.indexOf(key);
      if (generalParamIndex !== -1) {
        generalParams.splice(generalParamIndex, 1);
        searchParams.delete(key);
      }
    }
  }

  const searchParamsString = [...searchParams.entries()].length ? `?${searchParams.toString()}` : '';
  const hashFragmentString = hashFragment ? `#${hashFragment}` : '';

  const url = `${currentPath}${searchParamsString}${hashFragmentString}`;

  replaceOrPushHistoryState(url);
};

export const getSearchString = (url = ''): string => {
  return url.split('?')[1];
};

export const getSearchParams = (url: string): [string, string][] | undefined => {
  if (!url) return;

  try {
    const searchString: string = getSearchString(url);
    const searchParams: URLSearchParams = new URLSearchParams(searchString);

    return [...searchParams.entries()];
  } catch (err) {
    console.log('error at hasSearchParams');
    console.error(err);
  }
};

export const getSearchParamsAndHashFragment = url => {
  const [currentPath, queryParams = '']: string[] = url.split('?');
  const [searchString = '', hashFragment = '']: string[] = queryParams.split('#');

  const searchParams: URLSearchParams = new URLSearchParams(searchString);

  const hasSearchParams = !![...searchParams.entries()].length;
  const hasHashFragment = !!hashFragment;

  const searchParamsString: string = hasSearchParams ? `?${searchParams.toString()}` : '';
  const hashFragmentString: string = hasHashFragment ? `#${hashFragment}` : '';

  return {
    currentPath,
    hasSearchParams,
    searchParams,
    searchParamsString,
    hasHashFragment,
    hashFragment,
    hashFragmentString,
  };
};

export const helpClickHandler = baseUrl => {
  window.open(`${baseUrl}betting-guides/myoc-premium-faqs`, '_blank');
};

export const userTypeHelper = (isLoggedIn: boolean, isPremiumUser: boolean) => {
  if (!isLoggedIn) return 'logged out user';

  if (isPremiumUser) return 'logged in premium user';
  return 'logged in free user';
};

export const articleTypeHelper = (isPremium: boolean, premiumDisplay: string) => {
  const showPaywall = premiumDisplay === 'changePlan' || premiumDisplay === 'premiumUpgrade';

  if (isPremium) {
    if (showPaywall) return 'Blocked Content';
    return 'Premium';
  }
  return 'Free';
};

export const concatenateArticleAuthors = (authors: IArticleAuthor[]): string => {
  if (!authors?.length) return '';

  return authors.map(({ fullName }) => fullName).join('&');
};

/**
 * Replaces a substring in a string. Values must not be undefined or simply returns
 * original string.
 *
 * @param original The original string
 * @param substring The string you are searching for
 * @param substitute The string you are replacing substring with
 */
export const replaceSubstring = (original: string, substring?: string, substitute?: string): string => {
  if (substring && substitute) {
    return original.replace(substring, substitute);
  }

  return original;
};
